type CarImageProps = {
  src: string
}
export function CarImage({ src }: CarImageProps) {
  return (
    <div>
      <img src={src} width='100%' height='auto' alt='mainCar' />
    </div>
  )
}
